module.exports = __webpack_public_path__ + "img/Entrance---edited.987eccf6.jpg";